<div class="app-private-chat" [hidden]="(router.url.includes('/stream/') && (!contactInfo || !openPrivateChat)) || router.url.includes('/community')" [ngClass]="{'right-side-menu':router.url.includes('/stream/'),'pc-right':(contactInfo && contactInfo?.name)}">
    <div [ngClass]="{'h-460':open,'remove-shadow':router.url.includes('/stream/'),'pc-box':contactInfo && contactInfo?.name,'stream-c-div': router.url.includes('/stream/')}" fxLayout="column" class="box"
    [ngStyle]="settingsData?.bg_primary_color ? {'background-color': settingsData?.bg_primary_color} : {}">
        <div class="contact-box" [ngClass]="{'box-bottom':open,'contact-box-bg':router.url.includes('/stream/')}"
        [ngStyle]="settingsData?.bg_primary_color ? {'background-color': settingsData?.bg_primary_color, 'color': settingsData?.font_primary_color} : {}">
            <div fxLayout="row">
                <div fxFlex="80%">
                    <h1 class="heading pointer w-100" [ngClass]="{'fs-16':router.url.includes('/stream/')}" *ngIf="content =='Contacts'" (click)="openContactBox(router.url.includes('/stream/'))">
                        <span [ngStyle]="{'color':settingsData?.font_primary_color}">{{content}}</span>
                    </h1>
                    <ng-container *ngIf="content =='Add Contact' || content =='Fans Online'">
                        <div fxFlex="10%"><i class="fa fa-angle-left left-arrow pointer" [ngClass]="{'pl-16':router.url.includes('/stream/')}" aria-hidden="true"
                                (click)="goToContactsList()"></i></div>
                        <div fxFlex="90%" class="pointer">
                            <h1 class="heading" [ngClass]="{'c-name':router.url.includes('/stream/')}" (click)="openContactBox(router.url.includes('/stream/'))"><span>{{content}}<span *ngIf="msgCount && msgCount.length > 0"><i class="fa fa-circle active-fans" aria-hidden="true"></i></span></span></h1>
                        </div>
                    </ng-container>
                    <div fxLayout="row" fxFlex="100%"
                        *ngIf="content !='Fans Online' && content !='Add Contact' && content !='Contacts'">
                        <i class="fa fa-angle-left pointer fs-22 plr-10 pt-13" aria-hidden="true"
                            (click)="backToContacts()"></i>
                        <div fxFlex="10%" class="roundIcon1 text-center mt-9" *ngIf="!toggleViewContact">
                            <div class="roundIcon1 text-center" *ngIf="contactData?.profile_pic; else userName">
                                <img class="roundUserImage1" src="{{contactData?.contact_details.profile_pic}}">
                            </div>
                            <ng-template #userName>
                                <div class="roundIcon1 text-center"
                                    [ngStyle]="{'background-color': contactData?.contact_details.userColor }">
                                    <span class="text-uppercase notranslate">{{contactData?.contact_details.shortName}}</span>
                                </div>
                            </ng-template>
                        </div>
                        <div fxFlex="90%" *ngIf="!toggleViewContact">
                            <h1 class="heading pointer text-capitialize" [ngClass]="{'p-name':router.url.includes('/stream/')}" *ngIf="content && content.length <= 33"
                                (click)="openContactBox()">
                                {{content}}</h1>
                            <h1 class="heading pointer text-capitialize" [ngClass]="{'p-name':router.url.includes('/stream/')}" *ngIf="content && content.length > 33"
                                matTooltipPosition="above" matTooltip="{{content}}" (click)="openContactBox()">
                                {{content}}</h1>
                        </div>
                    </div>
                    <!-- <h1 class="heading pl-10 text-capitialize" *ngIf="content !='Add Contact' && content !='Contacts'"><i
                                    class="fa fa-angle-left pointer" aria-hidden="true" (click)="backToContacts()"></i>
                                <span class="roundIcon text-center" *ngIf="contactData?.profile_pic; else userName">
                                    <img class="roundUserImage" src="{{contactData?.contact_details.profile_pic}}">
                                </span>
                                <ng-template #userName>
                                    <span class="roundIcon text-center" [ngStyle]="{'background-color': contactData?.contact_details.userColor }">
                                        <span class="text-uppercase">{{contactData?.contact_details.shortName}}</span>
                                    </span>
                                </ng-template><span class="pl-10">{{content}}</span>
                            </h1> -->
                </div>
                <div fxFlex="20%">
                    <ng-container
                        *ngIf="open && (content =='Contacts' || (content !='Add Contact' && content != 'Fans Online')) && !toggleViewContact">
                        <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-icon" (click)="updateMenuBackground()"
                            [ngClass]="{'menu':open && (content=='Add Contact' || content=='Contacts' || content == 'Fans Online'),'right-menu-icon':router.url.includes('/stream/')}">
                            <mat-icon class = "material-icons-padding"  [ngStyle]="settingsData?.form_bg_tertiary_color ? {'background-color': settingsData?.form_bg_tertiary_color,'color':settingsData?.form_font_secondary_color} : {}">more_vert</mat-icon>
                        </button>
                    </ng-container>
                    <mat-menu #menu="matMenu" backdropClass="custom-menu">
                        <ng-container *ngIf="open && content =='Contacts'">

                            <button mat-menu-item (click)="goToAddContact()" [ngStyle]="{'background-color':settingsData?.bg_primary_color}">
                                <span [ngClass]="{'c-p':content =='Add Contact'}" [ngStyle]="{'color':settingsData?.event_button_font_primary_color}">Add Contact</span>
                            </button>
                            <!-- <button mat-menu-item (click)="goToFansList()"
                                *ngIf="router.url.includes('/stream/') || router.url.includes('/event/schedule/')">
                                <span [ngClass]="{'c-p':content =='Fans Online'}">Fans Online</span>
                            </button> -->
                            <!-- <button mat-menu-item disabled>
                                <mat-icon>voicemail</mat-icon>
                                <span>Check voicemail</span>
                            </button> -->
                            <!-- <button mat-menu-item>
                                <span>New Group</span>
                            </button> -->
                        </ng-container>
                        <ng-container *ngIf="open && content !='Contacts'">
                            <button mat-menu-item (click)="viewContact()" *ngIf="redirectTo != 'Fans Online'">
                                <span [ngClass]="{'c-p':toggleViewContact}">View Contact</span>
                            </button>
                            <ng-container *ngIf="redirectTo == 'Fans Online'">
                                <button mat-menu-item (click)="viewContact('fans')"
                                    *ngIf="contactData?.accepted && contactData?.accepted.indexOf(userInfo.id) != -1">
                                    <span [ngClass]="{'c-p':toggleViewContact}">View Contact</span>
                                </button>
                                <button mat-menu-item (click)="sendRequest(contactData)"
                                    *ngIf="contactData?.sent && contactData?.sent.indexOf(userInfo.id) == -1 && contactData?.received.indexOf(userInfo.id) == -1 && contactData?.accepted.indexOf(userInfo.id) == -1 && contactData?.rejected.indexOf(userInfo.id) == -1 && !contactData?.disableContact">
                                    <span [ngClass]="{'c-p':toggleViewContact}">Send Request</span>
                                </button>
                                <button mat-menu-item disabled
                                    *ngIf="(contactData?.received && contactData?.received.indexOf(userInfo.id) != -1 && contactData?.accepted && contactData?.accepted.indexOf(userInfo.id) == -1) || (contactData?.rejected && contactData?.rejected.indexOf(userInfo.id) != -1) || (contactData?.disableContact)">
                                    <span [ngClass]="{'c-p':toggleViewContact}">Contact Received</span>
                                </button>
                            </ng-container>
                            <!-- <button mat-menu-item disabled>
                                <mat-icon>voicemail</mat-icon>
                                <span>Check voicemail</span>
                            </button> -->
                            <button mat-menu-item *ngIf="redirectTo !='Fans Online'" (click)="blockContact()">
                                <span>Block</span>
                            </button>
                            <button mat-menu-item (click)="clearChatHistory()" hidden>
                                <span>Clear Conversation</span>
                            </button>
                        </ng-container>
                    </mat-menu>
                    <span class="arrow pointer" [ngClass]="{'pr-15':!open}" (click)="openContactBox()" [hidden]="router.url.includes('/stream/')"><i
                            class="fa fa-angle-down down-arrow pt-17 fs-16" *ngIf="!open" aria-hidden="true"></i>
                        <i class="fa fa-angle-up up-arrow pt-16 fs-16"
                            *ngIf="open && (content=='Add Contact' || content=='Contacts' || content == 'Fans Online')"
                            [ngClass]="{'pr-15':(content=='Add Contact' || content == 'Fans Online' || content!='Contacts')}"
                            aria-hidden="true"></i>
                    </span>
                </div>
            </div>
        </div>
        <ng-container *ngIf="open">
            <div class="search-box mlr-10 mt-15 ml-15 mb-5 relative" [ngClass]="{'pl-0':toggleViewContact}"
                [ngStyle]="settingsData?.form_bg_color ? {'background-color': settingsData?.form_bg_color} : {}"
                *ngIf="content == 'Add Contact'" fxLayout="row" fxFlex="100%">
                <div class="pointer pt-8" fxFlex="10%">
                    <i class="fa fa-search pl-10 text-white" aria-hidden="true"></i>
                </div>
                <div class="w-100">
                    <textarea (ngModelChange)="getSearchContacts($event)" (keydown.enter)="getSearchContacts(searchContact)" placeholder="Search users"
                        [(ngModel)]="searchContact" class="fs-14 live-message-box text-white c-box" fxFlex="90%"></textarea>
                    <i class="fa fa-spinner pt-12" *ngIf="showLoader" aria-hidden="true"></i>
                </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="start start" class="contact-inner-box pl-15"
                [ngClass]="{'h-315':content != 'Contacts' && content != 'Add Contact' && !toggleViewContact,'stream-chat-div':router.url.includes('/stream/'),'o-auto':(contactsList && contactsList.length > 0 && content == 'Contacts')}">
                <ng-container *ngIf="searchContactsData && searchContactsData.length > 0 && content == 'Add Contact'">
                    <ng-container *ngFor="let a of searchContactsData;">
                        <div class="ptb-5 w-100 bottom-border mr-10">
                            <div fxFlex="10%" class="roundIcon text-center" *ngIf="a?.profile_pic; else userName">
                                <img class="roundUserImage" src="{{a?.profile_pic}}">
                            </div>
                            <ng-template #userName>
                                <div fxFlex="10%" class="roundIcon text-center"
                                    [ngStyle]="{'background-color': a?.userColor }">
                                    <span class="text-uppercase notranslate">{{a?.shortName}}</span>
                                </div>
                            </ng-template>
                            <div class="pl-10 pt-10 tertiary-bg-font-color2" fxFlex="70%">
                                <span class="fs-16"
                                    *ngIf="a?.user_display_name && a?.user_display_name.length < 20">{{a?.user_display_name}}</span>
                                <span class="fs-16 tertiary-bg-font-color2" *ngIf="a?.user_display_name && a?.user_display_name.length >= 20"
                                    matTooltipPosition="above"
                                    matTooltip="{{a?.user_display_name}}">{{a?.user_display_name|limitTo:20}}...</span>
                                <!-- <span class="msg" [innerHTML]="a.message"></span> -->
                            </div>
                            <div fxFlex="20%" class="pt-10 text-right">
                                <button mat-flat-button [disabled]="a.isAddedContact"
                                    [ngClass]="{'slick-disabled':a.isAddedContact}" class="add-btn"
                                    (click)="addContact(a)">
                                    Add
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container
                    *ngIf="searchContact && searchContactsData && searchContactsData.length == 0 && content == 'Add Contact'">
                    <h6 class="fs-16 plr-40 ml-50 pt-30 white-text">No records found</h6>
                    <!-- <div fxFlex="10%" class="roundIcon text-center">
                        <div fxFlex="10%" class="roundIcon text-center" [ngStyle]="{'background-color': '#0E7B62' }">
                            <span class="text-uppercase">{{name}}</span>
                        </div>
                    </div>
                    <div class="pl-10 pt-10" fxFlex="67%">
                        <span class="fs-16" *ngIf="searchContact && searchContact.length < 20">{{searchContact}}</span>
                        <span class="fs-16" *ngIf="searchContact && searchContact.length >= 20"
                            matTooltipPosition="above"
                            matTooltip="{{searchContact}}">{{searchContact|limitTo:20}}...</span>
                    </div>
                    <div fxFlex="20%" class="pt-10">
                        <button mat-flat-button class="add-btn" (click)="inviteContact(a)">
                            Invite
                        </button>
                    </div> -->
                </ng-container>
                <ng-container *ngIf="fansList && fansList.length > 0 && content == 'Fans Online'">
                    <div class="search-box mr-10 mt-15 mb-5 relative" [ngStyle]="settingsData?.form_bg_color ? {'background-color': settingsData?.form_bg_color} : {}" 
                    fxLayout="row" fxFlex="100%">
                        <div class="pointer pt-8" fxFlex="10%">
                            <i class="fa fa-search pl-10 text-white" aria-hidden="true"></i>
                        </div>
                        <div class="w-100">
                            <textarea placeholder="Search fans" [(ngModel)]="searchContact"
                                class="fs-14 live-message-box text-white" fxFlex="90%"></textarea>
                        </div>
                    </div>
                    <ng-container *ngIf="( fansList | filter : searchContact:'name') as fanData">
                    <ng-container *ngFor="let a of fanData | filter: searchContact:'name'">
                        <div class="ptb-5 w-100 bottom-border">
                            <ng-container *ngIf="a?.messageReceived"><i class="fa fa-circle notify" aria-hidden="true"></i></ng-container>
                            <div fxFlex="10%" class="roundIcon text-center" *ngIf="a?.profile_pic; else userName">
                                <img class="roundUserImage" src="{{a?.profile_pic}}">
                            </div>
                            <ng-template #userName>
                                <div fxFlex="10%" class="roundIcon text-center"
                                    [ngStyle]="{'background-color': a?.userColor }">
                                    <span class="text-uppercase notranslate">{{a?.shortName}}</span>
                                </div>
                            </ng-template>
                            <div class="pl-10 pt-10 tertiary-bg-font-color2" fxFlex="{{a.sent.indexOf(this.userInfo.id) != -1 && a.accepted.indexOf(this.userInfo.id) == -1 ? 59 : 70}}">
                                <div class="fs-16 e-text tertiary-bg-font-color2" *ngIf="a?.name && a?.name.length < 20">{{a?.name}}</div>
                                <div class="fs-16 e-text tertiary-bg-font-color2" *ngIf="a?.name && a?.name.length >= 20" matTooltipPosition="above"
                                    matTooltip="{{a?.name}}">{{a?.name}}</div>

                            </div>
                            <div fxFlex="{{a.sent.indexOf(this.userInfo.id) != -1 && a.accepted.indexOf(this.userInfo.id) == -1 ? 31 : 15}}" class="text-right icons-size">
                                <ng-container
                                    *ngIf="a.sent.indexOf(this.userInfo.id) != -1 && a.accepted.indexOf(this.userInfo.id) == -1">
                                    <i class="fa fa-check-circle accept mr-10 pointer"
                                        (click)="processContactRequest(a,'accept')" matTooltipPosition="above"
                                        matTooltip="Accept" aria-hidden="true"></i>
                                    <i class="fa fa-times-circle reject pointer mr-10"
                                        (click)="processContactRequest(a,'reject')" matTooltipPosition="above"
                                        matTooltip="Reject" aria-hidden="true"></i>
                                </ng-container>
                                <!-- <ng-container *ngIf="a.rejected.indexOf(userInfo.id) != -1">
                                    <i class="fa fa-times-circle reject slick-disabled" matTooltipPosition="above"
                                        matTooltip="Rejected" aria-hidden="true"></i>
                                </ng-container> -->
                                <ng-container>
                                    <i class="fa fa-comments pointer" matTooltipPosition="above" matTooltip="Chat"
                                        aria-hidden="true" (click)="startChat(a,'Fans Online')"></i>
                                </ng-container>
                                <!-- <ng-container *ngIf="a.accepted.indexOf(userInfo.id) != -1">
                                    <i class="fa fa-comments pointer" matTooltipPosition="above" matTooltip="Chat"
                                        aria-hidden="true" (click)="startChat(a,'Fans Online')"></i>
                                </ng-container> -->
                                <!-- <ng-container
                                    *ngIf="a.sent.indexOf(userInfo.id) == -1 && a.received.indexOf(userInfo.id) == -1 && a.accepted.indexOf(userInfo.id) == -1 && a.rejected.indexOf(userInfo.id) == -1">
                                    <i class="fa fa-plus-circle pointer" matTooltipPosition="above" matTooltip="Send Request"
                                        aria-hidden="true" (click)="sendRequest(a)"></i>
                                </ng-container>
                                <ng-container
                                    *ngIf="a.received.indexOf(userInfo.id) != -1 && a.accepted.indexOf(userInfo.id) == -1">
                                    <i class="fa fa-clock-o" matTooltipPosition="above" matTooltip="Request Pending"
                                        aria-hidden="true"></i>
                                </ng-container> -->
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="fanData.length == 0" class="text-center w-100 p-20 white-text">No records found</div> 
                </ng-container>
                </ng-container>
                <ng-container *ngIf="contactsList && contactsList.length > 0 && content == 'Contacts'">
                    <div class="search-box mr-10 mt-15 mb-5 relative" *ngIf="content == 'Contacts'" fxLayout="row"
                        fxFlex="100%" [ngStyle]="settingsData?.form_bg_color ? {'background-color': settingsData?.form_bg_color} : {}">
                        <div class="pointer pt-8" fxFlex="10%">
                            <i class="fa fa-search pl-10 text-white" aria-hidden="true"></i>
                        </div>
                        <div class="w-100">
                            <textarea placeholder="Search Contact" (keydown.enter)="filterContacts(searchContact)" [(ngModel)]="searchContact"
                                class="fs-14 live-message-box text-white cl-box" fxFlex="90%"></textarea>
                            <!-- <mat-icon matSuffix *ngIf="showLoader">
                                <mat-spinner color="warn" diameter="20">
                                </mat-spinner>
                            </mat-icon> -->
                            <i class="fa fa-spinner pt-12" *ngIf="showLoader" aria-hidden="true"></i>
                        </div>
                    </div>
                    <ng-container *ngIf="( contactsList | filter : searchContact:'name') as CData">
                    <ng-container *ngFor="let a of CData | filter: searchContact:'name'">
                        <div class="ptb-5 w-100 bottom-border pointer" (click)="startChat(a,'Contacts')">
                            <div fxFlex="10%" class="roundIcon text-center"
                                *ngIf="a?.contact_details?.profile_pic; else userName">
                                <img class="roundUserImage" src="{{a?.contact_details?.profile_pic}}">
                            </div>
                            <ng-template #userName>
                                <div fxFlex="10%" class="roundIcon text-center"
                                    [ngStyle]="{'background-color': a?.contact_details?.userColor }">
                                    <span class="text-uppercase notranslate">{{a?.contact_details?.shortName}}</span>
                                </div>
                            </ng-template>
                            <div class="plr-10 text-secondary e-text" fxFlex="{{a.createdAt ? 70 : 90}}" [ngClass]="{'pt-10':!a?.message}" [style.color]="settingsData?.font_primary_color +'!important'" >
                                <span class="fs-16" *ngIf="a?.name && a?.name.length < 18">{{a?.name}}</span>
                                <span class="fs-16" *ngIf="a?.name && a?.name.length >= 18" matTooltipPosition="above"
                                    matTooltip="{{a?.name}}">{{a?.name}}</span>
                                <div>{{a?.message}}</div>
                            </div>
                            <div class="pt-10 text-right mr-10" *ngIf="a?.createdAt" fxFlex="20%">
                                <div class="text-secondary fs-12 notranslate">{{a?.createdAt}}</div>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="CData.length == 0" class="text-center w-100 p-20 white-text">No records found</div> 
                </ng-container>
                </ng-container>
                <ng-container
                    *ngIf="content != 'Contacts' && content != 'Add Contact' && content != 'Fans Online' && !toggleViewContact">
                    <ng-container *ngIf="isCheckingChannel; else contentLoading">
                        <div class="w-100 chat-box" [ngClass]="{'stream-chat-box':router.url.includes('/stream/')}">
                            <div id="p-chat-inner-box" class="chat-inner-box pr-15" [ngClass]="{'pc-inner-box':contactInfo && contactInfo?.name,'stream-inner-box':router.url.includes('/stream/')}">
                                <ng-container *ngFor="let a of messageList;">
                                    <div class="d-flex" [ngClass]="{'dir-rtl':(a.isSender || a._sender?.isSender)}">
                                    <div class="mt-10 received-msg"
                                        [ngClass]="{'user-msg':(a.isSender || a._sender?.isSender)}"
                                        [ngStyle]="settingsData?.form_bg_color ? {'background-color': (a.isSender || a._sender?.isSender) ? settingsData?.form_bg_color : settingsData?.form_font_secondary_color} : {}">
                                        <!-- <div fxFlex="9%" fxFlex.md="12%" fxFlex.sm="4%" fxFlex.xs="4%"
                                            class="roundIcon text-center mr-15"
                                            *ngIf="a._sender?.profileUrl; else userName">
                                            <img class="roundUserImage" src="{{a._sender?.profileUrl}}">
                                        </div>
                                        <ng-template #userName>
                                            <div fxFlex="9%" fxFlex.md="12%" fxFlex.sm="4%" fxFlex.xs="4%"
                                                class="roundIcon text-center mr-15"
                                                [ngStyle]="{'background-color': a._sender?.userColor }">
                                                <span class="text-uppercase">{{a._sender?.shortName}}</span>
                                            </div>
                                        </ng-template> -->
                                        <!-- <div class="person pr-15"
                                            [ngClass]="{'text-right':a.isSender,'lh-40':a.message.length<=22}"
                                            fxFlex="100%"> -->
                                            <!-- <span class="fw-500 text-capitialize" [ngStyle]="{'color': a._sender?.userColor }">
                                        {{a._sender?.nickname}}
                                    </span> -->
                                    <!-- <div class="my-messege-div"> -->
                                        <div [innerHTML]="a.message" [ngClass]="{'dir-ltr':(a.isSender || a._sender?.isSender)}">
                                        </div>
                                        <div class="fs-11" [ngClass]="{'dir-ltr':(a.isSender || a._sender?.isSender)}">{{a.time}}</div>
                                    <!-- </div> -->
                                            <!-- <span class="msg" [innerHTML]="a.message"></span>
                                            <span class="fs-12 pl-10"></span> -->
                                        <!-- </div> -->
                                    </div>
                                </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #contentLoading>
                        <div fxFlex="100%" class="mt-10">
                            <content-loading [width]="'width85Per'"></content-loading>
                            <content-loading [width]="'width65Per'"></content-loading>
                            <content-loading [width]="'width45Per'"></content-loading>
                            <content-loading [width]="'width30Per'"></content-loading>
                            <content-loading [width]="'width45Per'"></content-loading>
                            <content-loading [width]="'width85Per'"></content-loading>
                            <content-loading [width]="'width65Per'"></content-loading>
                            <content-loading [width]="'width45Per'"></content-loading>
                            <content-loading [width]="'width30Per'"></content-loading>
                            <content-loading [width]="'width85Per'"></content-loading>
                            <content-loading [width]="'width65Per'"></content-loading>
                            <content-loading [width]="'width45Per'"></content-loading>
                            <content-loading [width]="'width30Per'"></content-loading>
                        </div>
                    </ng-template>
                    <div class="send-chat-msg mb-10 relative" fxLayout="row"
                        [ngStyle]="settingsData?.form_bg_color ? {'background-color': settingsData?.form_bg_color} : {}">
                        <div class="smile-icon text-center fs-20 pointer" fxFlex="10%">
                            <i class="fa fa-smile-o secondary-bg-font-color1" *ngIf="!isShowEmoji" aria-hidden="true"
                                (click)="openCloseEmoji()"></i>
                            <i class="fa fa-angle-down" *ngIf="isShowEmoji" aria-hidden="true"
                                (click)="openCloseEmoji()"></i>
                        </div>
                        <div class="pt-12 mr-10" fxFlex="73%">
                            <textarea placeholder="Send a message" 
                                [ngClass]="{'sendMessageText':sendMessageText && sendMessageText.length>22}"
                                [(ngModel)]="sendMessageText" class="fs-15 chat-message-box w-100"
                                (keydown.enter)="sendMessage()"></textarea>
                        </div>
                        <!-- [ngClass]="{'slick-disabled':isBlockContact}"
                                [disabled]="isBlockContact" -->
                        <div class="send-icon text-center fs-20 pointer mt-9" fxFlex="15%" fxFlex.xs="25%"
                        [ngStyle]="settingsData?.form_font_secondary_color ? {'background-color': settingsData?.form_font_secondary_color} : {}">
                            <span class="material-icons pointer notranslate fs-18" (click)="sendMessage()">
                                send
                            </span>
                        </div>
                        <div class="network-emoji-mart" [ngClass]="{'emojiShow': isShowEmoji,  'emojiNone': !isShowEmoji }">
                            <emoji-mart #emojiMartRef [showPreview]="false" [isNative]="true" [set]="native"
                                (emojiClick)="addEmoji($event)" [showSingleCategory]="false"
                                [emojisToShowFilter]="filterEmoji" [enableSearch]="false"
                                [style]="{ width: '345px',position: 'absolute', bottom: '60px', left: '0px' }">
                            </emoji-mart>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="content != 'Contacts' && content != 'Add Contact' && toggleViewContact">
                    <!-- <div class="d-contents"> -->
                    <div fxLayout="column" class="w-100 white-text">
                        <div *ngIf="contactData.contact_details.profile_pic; else defaultPic">
                            <img class="user-profile" src="{{contactData.contact_details.profile_pic}}">
                        </div>
                        <ng-template #defaultPic>
                            <!-- <div class="user-profile"> -->
                            <img class="user-profile" [src]="assets_url + 'default.png'">
                            <!-- </div> -->
                        </ng-template>

                        <h1 class="ff fs-20 text-capitalize mb-0 pb-5">{{contactData.contact_details.name}}</h1>
                        <p *ngIf="contactData?.contact_details?.email"><span><i class="fa fa-envelope cont-icon pr-10"
                                    aria-hidden="true"></i>
                                <span class="fs-16"
                                    *ngIf="contactData?.contact_details?.email.length < 28">{{contactData?.contact_details?.email}}</span>
                                <span class="fs-16" *ngIf="contactData?.contact_details?.email.length >= 28"
                                    matTooltipPosition="above"
                                    matTooltip="{{contactData?.contact_details?.email}}">{{contactData?.contact_details?.email|limitTo:28}}...</span></span>
                        </p>
                        <p
                            *ngIf="contactData?.contact_details.phone_number && contactData?.contact_details?.phone_number.length > 5">
                            <i class="fa fa-phone pr-10"
                                aria-hidden="true"></i>{{contactData?.contact_details?.phone_number}}
                        </p>
                    </div>
                </ng-container>
            </div>
            <div class="continue-btn pointer" (click)="startChat(contactData,'Add Contact','add')"
                [ngStyle]="settingsData?.form_font_secondary_color ? {'background-color': settingsData?.form_font_secondary_color} : {}"
                *ngIf="content == 'Add Contact' && contactData && contactData?.isAddedContact">
                <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
            </div>
        </ng-container>
    </div>
</div>